import "!style-loader!css-loader?sourceMap=true!@fortawesome/fontawesome-pro/css/all.css";
// prefix !style-loader!css-loader?sourceMap=true! => webpack load in the DOM
// * @fortawesome here is not an error, it is the official package, do NOT import @fontawesome package it is very old and no longer supported
// see https://fontawesome.com/how-to-use/on-the-web/setup/using-package-managers

/**
 * Calling importFontAwesome6 ensures the import above is parsed by webpack
 */
export function importFontAwesome6(): void {
    // nothing to do
}